"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var Suffix_1 = require("./src/Suffix");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(Suffix_1).default; } });
